import { Button, Dialog, TextInput, Typography, toast } from '@neo4j-ndl/react';
import { fleetManagementApi, useActiveProject } from '@nx/state';
import { useState } from 'react';

type RenameDbmsModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  dbmsId: string;
  currentName: string;
};

export const RenameDbmsModal = ({ isOpen, closeModal, dbmsId, currentName }: RenameDbmsModalProps) => {
  const activeProject = useActiveProject();
  const [newName, setNewName] = useState(currentName);
  const [renameDbms, { isLoading }] = fleetManagementApi.useRenameDbmsMutation();

  const isValidDbmsName = (name: string | undefined) => {
    return name !== undefined && name.length >= 1 && name.length <= 30;
  };

  const newNameValidator = (name: string | undefined) => {
    return isValidDbmsName(name) ? undefined : (
      <div>
        <Typography variant="body-medium">Name should be between 1 and 30 characters</Typography>
      </div>
    );
  };

  return (
    <Dialog size="small" isOpen={isOpen} onClose={closeModal}>
      <Dialog.Header>Rename deployment</Dialog.Header>
      <Dialog.Content>
        <TextInput
          label="New name"
          aria-label="Input new name"
          isFluid
          value={newName}
          errorText={newNameValidator(newName)}
          onChange={(e) => setNewName(e.target.value)}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button
          fill="outlined"
          color="neutral"
          onClick={() => {
            setNewName(currentName);
            closeModal();
          }}
        >
          Cancel
        </Button>
        <Button
          fill="filled"
          color="primary"
          onClick={() => {
            void renameDbms({
              projectId: activeProject.id,
              dbmsId: dbmsId,
              name: newName,
            })
              .then(({ error }) => {
                if (error) {
                  toast.danger('Failed to rename deployment', { shouldAutoClose: true });
                } else {
                  toast.success('Deployment renamed', { shouldAutoClose: true });
                  closeModal();
                }
              })
              .catch((err: Error) => {
                toast.danger(err.message);
              });
          }}
          isLoading={isLoading}
          isDisabled={!newName || newName === currentName || !isValidDbmsName(newName)}
        >
          Rename
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};
